import { Clock } from "lucide-react";
import { useOrders } from "../../orders-context";
import { FilterSelect2 } from "src/@/components/ui/filter-select-2";
import { useCustomHoursEnabled } from "#navigation/utils";
import { t } from "@lingui/core/macro";
type CustomHourOption = {
    value: string;
    label: string;
};

export const OrdersCustomHourPicker = () => {
    const { customHourOffset, setCustomHourOffset } = useOrders();

    const options: CustomHourOption[] = [
        { value: "0", label: "12am to 12am" },
        { value: "1", label: "1am to 1am" },
        { value: "2", label: "2am to 2am" },
        { value: "3", label: "3am to 3am" },
        { value: "4", label: "4am to 4am" },
        { value: "5", label: "5am to 5am" },
        { value: "6", label: "6am to 6am" },
    ];

    const customHoursEnabled = useCustomHoursEnabled();

    if (!customHoursEnabled) {
        return null;
    }

    return (
        <FilterSelect2
            title={t`Custom Hours`}
            icon={Clock}
            selectedValues={new Set([customHourOffset])}
            options={options}
            onOptionSelected={(value) => setCustomHourOffset(value)}
        />
    );
};
